import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadContentPublishStatus from '../loadContentPublishStatus'

const fetchContentPublishStatus = (contentId) =>
  HttpClient().get(`/api/v1/content/${contentId}/publishing_status`)

const getContentPublishStatus = (contentId) => (dispatch) =>
  fetchContentPublishStatus(contentId)
    .then((response) =>
      dispatch(loadContentPublishStatus(parseJSONApiResponse(response.data)))
    )
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getContentPublishStatus
